import { __assign } from "tslib";
import { renderAndMountComponent, createTestHistory } from '@wix/answers-lib';
import * as React from 'react';
import { Link } from './link.comp';
import { Router } from 'react-router';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createLinkDriver = function (wrapper, optionalClass) {
    var optClass = optionalClass ? "." + optionalClass : '';
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, ".link" + optClass, Link.name);
    return {
        getType: function () { return baseDriver.hasClass('rr') ? 'rr' : 'html'; },
        getText: function () { return baseDriver.getText(); },
        hasArrow: function () { return baseDriver.isChildVisible('.arrow-icon'); },
        isDisabled: function () { return baseDriver.hasClass('disabled'); },
        hasEllipsis: function () { return baseDriver.hasClass('ellipsis'); },
        click: function () { return baseDriver.click(); }
    };
};
export var createLink = function (props) {
    var history = createTestHistory();
    var comp = props.href ? (React.createElement(Link, __assign({}, props, { href: props.href }), props.children)) : (React.createElement(Link, __assign({}, props, { to: props.to }), props.children));
    var elem = renderAndMountComponent(React.createElement(Router, { history: history }, comp));
    return createLinkDriver(elem);
};
//# sourceMappingURL=link.driver.js.map